// ToDo: please remove this when IE11 support is removed
import React, {Component} from 'react';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from './messages';
import clamp from 'clamp-js';

export default class TruncatedText extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.clamp();
    }

    componentDidUpdate() {
        this.clamp();
    }

    clamp() {
        if (this.props.oldBrowser) {
            const lineHeight = parseInt(window.getComputedStyle(this.base).getPropertyValue('line-height'));
            if (this.base.offsetHeight > this.props.lines * lineHeight) {
                clamp(this.base, {clamp: this.props.lines});
                MessageBroker.subscribe(Messages.WINDOW.RESIZED, () => {
                    clamp(this.base, {clamp: this.props.lines});
                });
            }
        }
    }

    render() {
        return (
            <span className={this.props.className} jsh-truncate-text={`${this.props.oldBrowser}`}>
                {this.props.children}
            </span>
        );
    }
}
